/* eslint-disable react/forbid-elements */
import * as React from 'react'

// Setting method and action to required so we dont accidentally do a GET with sensitive user data
interface IProps extends React.FormHTMLAttributes<HTMLFormElement> {
  method: string
  action: string
}

const BasicForm = (props: IProps) => {
  return <form {...props}>{props.children}</form>
}

export default BasicForm
